import { useMemo } from 'react';
import { EnterprisePricingCalculator, isEnterprisePricingTiers } from '../../utils/enterprise-pricing-calculator';
export function useEnterprisePricingCalculator(potentialTiers, minUsers, maxUsers) {
    const tiers = isEnterprisePricingTiers(potentialTiers)
        ? potentialTiers
        : [];
    const calculator = useMemo(() => new EnterprisePricingCalculator(tiers, minUsers, maxUsers), [tiers, minUsers, maxUsers]);
    return calculator;
}
//# sourceMappingURL=use-enterprise-pricing-calculator.js.map